import React, {useContext, useMemo, useState} from 'react';
import '@npoed/frontend-theme/dist/assets/scss/main.scss';
import "./learning-header.scss";

import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';
import Responsive from 'react-responsive';
import { ensureConfig } from '@edx/frontend-platform';
import Header from '../common/header';
import learningMessages from './messages';
import messages from '../Header.messages';
import Modal from 'react-modal';

function LinkedLogo({
  href,
  src,
  alt,
  ...attributes
}) {
  return (
    <a href={href} {...attributes}>
      <img className="d-block" src={src} alt={alt} />
    </a>
  );
}

LinkedLogo.propTypes = {
  href: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

ensureConfig([
  'PLP_BASE_URL',
  'REGISTER_URL',
  'COURSES_URL',
  'PROGRAMS_URL',
  'PARTNERSHIP_URL',
  'CATALOG_URL',
  'FEEDBACK_URL',
  'MY_COURSES_URL',
  'MY_PROGRAMS_URL',
  'ACCOUNT_URL',
  'ABOUT_URL',
], 'LearningHeader additional config');

function LearningHeader({
  intl,
  loginActionUrl,
  registerActionUrl,
  ...rest
}) {
  const { authenticatedUser, config } = useContext(AppContext);

  const menuItems = useMemo(() => [
    { labelKey: 'courses', href: config.COURSES_URL },
    { labelKey: 'programs', href: config.PROGRAMS_URL },
    { labelKey: 'partnership', href: config.PARTNERSHIP_URL },
    { labelKey: 'about', href: config.ABOUT_URL },
  ].map(menuItem => ({
    ...menuItem,
    label: intl.formatMessage(learningMessages[menuItem.labelKey]),
  })), [config, intl]);

  const authenticatedProfileMenuItems = useMemo(() => [
    { labelKey: 'myCourses', href: config.MY_COURSES_URL },
    { labelKey: 'myPrograms', href: config.MY_PROGRAMS_URL },
    { labelKey: 'account', href: config.ACCOUNT_URL },
    { labelKey: 'signOut', href: config.LOGOUT_URL },
  ].map(menuItem => ({
    ...menuItem,
    label: intl.formatMessage(learningMessages[menuItem.labelKey]),
  })), [config, intl]);

  const headerProps = {
    menuItems,
    authenticatedProfileMenuItems,
    isUserAuthenticated: !!authenticatedUser,
    auth: {
      loginLabel: intl.formatMessage(messages['header.user.menu.login']),
      loginHref: loginActionUrl || config.LOGIN_URL,
      registerLabel: intl.formatMessage(messages['header.user.menu.register']),
      registerHref: registerActionUrl || config.REGISTER_URL,
    },
    myProfileLabel: intl.formatMessage(learningMessages.myProfile),
    searchPlaceholder: intl.formatMessage(messages.search),
    ...rest,
  };

  return (
    <>
      <Responsive maxWidth={1050}>
        <Header
          {...headerProps}
          isMobile
        />
      </Responsive>
      <Responsive minWidth={1051}>
        <Header
          {...headerProps}
          isMobile={false}
        />
      </Responsive>
    </>
  );
}

LearningHeader.propTypes = {
  isFixed: PropTypes.bool,
  isTransparent: PropTypes.bool,
  isBviVisible: PropTypes.bool,
  loginActionUrl: PropTypes.string,
  registerActionUrl: PropTypes.string,
  intl: intlShape.isRequired,
};

LearningHeader.defaultProps = {
  isFixed: false,
  isTransparent: false,
  isBviVisible: false,
  loginActionUrl: undefined,
  registerActionUrl: undefined,
};

export default injectIntl(LearningHeader);
